export const businessBenefits = [
  {
    title: 'Appointments bookings',
    description:
      'Take control of your bookings with a simple calendar built for pet groomers. Add, rebook or cancel in seconds.',
  },
  {
    title: 'Client communications',
    description: 'Reduce no-shows and save time with automated reminders and client updates.',
  },
  {
    title: 'Services and locations for your grooming business',
    description: 'Run multiple grooming salons, or offer multiple services? Manage all bookings in one place.',
  },
  {
    title: 'Staff, shifts and schedule management',
    description:
      'Add unlimited team members then easily organise shifts, time off and services without the admin load.',
  },
];
